
export const classCompareStatisticsMap = {
  path: '/classCompareStatistics',
  component: () => import('@/views/classCompareStatistics/index.vue'),
  meta: { },
  children: [
    {
      path: 'height',
      component: () =>
        import(
          '@/views/classCompareStatistics/detail/height/index.vue'
        ),
      meta: { title: '身高分布' }
    },
    {
      path: 'bmi',
      meta: { title: 'BMI分布' },
      component: () =>
        import(
          '@/views/classCompareStatistics/detail/bmi/index.vue'
        )
    },
    {
      path: 'avg',
      meta: { title: '' },
      component: () => import('@/views/classCompareStatistics/detail/avg/index.vue'),
      children: [
        {
          path: 'index',
          meta: { title: '综合能力均分' },
          component: () => import('@/views/classCompareStatistics/detail/avg/main.vue')
        }
      ]
    },
    {
      path: 'distribution',
      component: () => import('@/views/classCompareStatistics/detail/distribution/index.vue'),
      meta: { title: '综合能力分布' }
    }
  ]
}
